/**
 * As portas de navegador de `preferencia.ts` — o `kv` do IndexedDB (`PWA §7.2`).
 *
 * O acesso ao banco passa por `abrirBanco()` de `pwa/armazenamento/portas.ts`, que continua
 * sendo o unico lugar que abre `fs-app` e aplica a migracao do esquema. Abrir o banco aqui de
 * novo criaria uma segunda definicao de versao — e o modo de falha de duas versoes divergentes
 * de IndexedDB e um `VersionError` que so aparece no aparelho de quem ja tinha o app instalado.
 *
 * O `keyPath` de `kv` e `chave` (`esquema.ts`), entao o registro e `{ chave, valor }`.
 */

import { abrirBanco } from '../pwa/armazenamento/portas.js';

import { CHAVE_DA_LOJA, STORE_KV, interpretar, serializar, type LojaPreferida, type PortasDaLoja } from './preferencia.js';

export function portasDaLojaDoNavegador(): PortasDaLoja {
  return {
    async lerDoBanco(): Promise<LojaPreferida | null> {
      if (typeof indexedDB === 'undefined') return null;
      const banco = await abrirBanco();
      if (!banco.objectStoreNames.contains(STORE_KV)) return null;
      const registro: unknown = await banco.get(STORE_KV, CHAVE_DA_LOJA);
      if (typeof registro !== 'object' || registro === null) return null;
      const { valor } = registro as { valor?: unknown };
      return typeof valor === 'string' ? interpretar(valor) : null;
    },

    async gravarNoBanco(loja: LojaPreferida): Promise<void> {
      if (typeof indexedDB === 'undefined') return;
      const banco = await abrirBanco();
      if (!banco.objectStoreNames.contains(STORE_KV)) return;
      await banco.put(STORE_KV, { chave: CHAVE_DA_LOJA, valor: serializar(loja) });
    },
  };
}
